import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { LoaderComponent } from './loader/loader.component';
import { CountDownComponent } from '../../../components/countdown/countdown.component';

@Component({
    selector: 'app-roulette-betting-timer',
    standalone: true,
    imports: [CommonModule, CountDownComponent, LoaderComponent],
    templateUrl: './betting-timer.component.html',
    styleUrl: './betting-timer.component.scss'
})
export class RouletteBettingTimerComponent implements OnChanges {
    @Input() initialTimeInSeconds!: number;
    @Input() hurryUpTimeInSeconds!: number;
    @Input() timeLeftInSeconds?: number;
    @Input() isClosed = false;

    progress = 1;
    currentCountdownTime = 0;
    isCountdownActive = true;
    hurryUp = false;
    ballShootIn = false;

    private readonly maxYellowTime = 5;

    private get totalArcTime(): number {
        return this.initialTimeInSeconds + this.maxYellowTime;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if ('initialTimeInSeconds' in changes && this.initialTimeInSeconds > 0) {
            this.resetTimer(this.initialTimeInSeconds);
            return;
        }

        if ('timeLeftInSeconds' in changes && this.timeLeftInSeconds !== undefined && this.timeLeftInSeconds > 0) {
            this.restartCountdown(this.timeLeftInSeconds);
        }
    }

    onProgress(progress: number): void {
        const elapsed = this.calculateElapsedTime(progress);
        this.progress = 1 - elapsed / this.totalArcTime;
    }

    onCountDownProgress(progress: number): void {
        const remainingTime = progress * this.currentCountdownTime;
        this.hurryUp = this.isInBettingPhase() && remainingTime <= this.hurryUpTimeInSeconds;
        this.ballShootIn = !this.isInBettingPhase();
    }

    onCountDownFinished(): void {
        this.isCountdownActive = false;
        this.hurryUp = false;
        this.ballShootIn = false;
    }

    private resetTimer(time: number): void {
        this.currentCountdownTime = time;
        this.progress = 1;
        this.isCountdownActive = true;
        this.hurryUp = false;
        this.ballShootIn = false;
    }

    private restartCountdown(time: number): void {
        this.currentCountdownTime = time;
        // Sync progress based on elapsed time from initial betting window
        const elapsed = this.initialTimeInSeconds - time;
        this.progress = 1 - elapsed / this.totalArcTime;
        this.isCountdownActive = false;
        setTimeout(() => (this.isCountdownActive = true));
    }

    private calculateElapsedTime(progress: number): number {
        const timeElapsed = (1 - progress) * this.currentCountdownTime;
        return this.isInBettingPhase() ? timeElapsed : this.initialTimeInSeconds + timeElapsed;
    }

    private isInBettingPhase(): boolean {
        return this.currentCountdownTime > this.maxYellowTime;
    }
}
